import { useState } from "react";
import { Badge, Button, Popover, PopoverSurface, PopoverTrigger, Text } from "@fluentui/react-components";
import { Alert20Regular } from "@fluentui/react-icons";
import { useNotifications } from "../api/hooks";
import { api } from "../api/client";
import { Link } from "react-router-dom";

export function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const q = useNotifications();
  const unread = q.data?.filter((n) => !n.isRead).length ?? 0;

  const markAll = async () => {
    await api.post("/api/notifications/read-all");
    q.refetch();
  };

  return (
    <Popover open={open} onOpenChange={(_, d) => setOpen(d.open)} positioning="below-end">
      <PopoverTrigger disableButtonEnhancement>
        <Button appearance="subtle" icon={<Alert20Regular />}>
          {unread > 0 && <Badge appearance="filled" color="danger" size="small">{unread}</Badge>}
        </Button>
      </PopoverTrigger>
      <PopoverSurface style={{ width: 360, maxHeight: 480, overflowY: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
          <Text weight="semibold">Notifications</Text>
          <Button size="small" appearance="subtle" onClick={markAll} disabled={unread === 0}>
            Mark all read
          </Button>
        </div>
        {(q.data ?? []).length === 0 ? (
          <Text size={200}>No notifications.</Text>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {(q.data ?? []).map((n) => (
              <Link
                key={n.id}
                to={n.ticket ? `/tickets/${n.ticket.id}` : "/my-tickets"}
                onClick={() => setOpen(false)}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  padding: 8,
                  borderRadius: 4,
                  background: n.isRead ? "transparent" : "rgba(98,100,167,0.08)",
                }}
              >
                <Text weight={n.isRead ? "regular" : "semibold"} block>{n.title}</Text>
                <Text size={200} block style={{ opacity: 0.8 }}>{n.body}</Text>
              </Link>
            ))}
          </div>
        )}
      </PopoverSurface>
    </Popover>
  );
}
